/* Shared by the Vue frontend and Razor backend. No authentication/recaptcha frames are changed. */
(function (global) {
  'use strict';
  if (global.NtuaCoep) return;

  function kindOf(frame) {
    var source = frame.getAttribute('src');
    if (!source) return null;
    var url;
    try { url = new URL(source, global.location.href); } catch (_) { return null; }
    if (url.protocol !== 'https:') return null;
    if (/^(www\.)?youtube(?:-nocookie)?\.com$/.test(url.hostname) && url.pathname.indexOf('/embed/') === 0) {
      return { url: url.href, label: '開啟影片 / Open video' };
    }
    if (/^(www\.)?google\.com$/.test(url.hostname) && url.pathname.indexOf('/maps/embed') === 0) {
      return { url: url.href, label: '開啟地圖 / Open map' };
    }
    return null;
  }

  function enhanceFrame(frame) {
    var kind = kindOf(frame);
    if (!kind) return;
    if ('credentialless' in global.HTMLIFrameElement.prototype) {
      if (!frame.hasAttribute('credentialless')) {
        frame.setAttribute('credentialless', '');
        // Late-inserted CMS content may already have started navigation. Reload once with isolation set.
        if (frame.isConnected) frame.src = kind.url;
      }
    } else {
      var link = document.createElement('a');
      link.href = kind.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.className = 'coep-external-content-link';
      link.textContent = kind.label;
      frame.replaceWith(link);
    }
  }

  function enhance(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.nodeType === 1 && root.tagName === 'IFRAME') enhanceFrame(root);
    Array.prototype.forEach.call(root.querySelectorAll('iframe'), enhanceFrame);
  }

  global.NtuaCoep = {
    // Like Vue v-html, this does not sanitize trusted CMS HTML. It only prepares supported embeds.
    prepareHtml: function (value) {
      var holder = document.createElement('template');
      holder.innerHTML = value == null ? '' : String(value);
      enhance(holder.content);
      return holder.innerHTML;
    },
    enhance: enhance
  };

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') enhance(record.target);
        else Array.prototype.forEach.call(record.addedNodes, enhance);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }
  enhance(document);
})(window);
